if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      if (typeof Swiper === 'undefined') {
        window.addEventListener('load', () => this.init(), { once: true });
        return;
      }

      const swiperContainer = this.querySelector('.swiper');
      if (!swiperContainer) return;

      const autoplay = this.dataset.autoplay === 'true';
      const speed = parseInt(this.dataset.speed, 10) || 5;
      const transitionSpeed = parseInt(this.dataset.transitionSpeed, 10) || 500;
      const loop = this.dataset.loop !== 'false';
      const effect = this.dataset.effect || 'slide';
      const direction = this.dataset.direction || 'horizontal';

      const config = {
        loop: loop,
        slidesPerView: 1,
        speed: transitionSpeed,
        effect: effect,
        direction: direction,
        allowTouchMove: true,
        grabCursor: false,
        navigation: {
          prevEl: this.querySelector('.slider-button--prev'),
          nextEl: this.querySelector('.slider-button--next'),
        },
      };

      if (effect === 'fade') {
        config.fadeEffect = { crossFade: true };
      }

      if (autoplay) {
        config.autoplay = {
          delay: speed * 1000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        config.speed = 0;
        if (config.autoplay) config.autoplay = false;
      }

      this.swiper = new Swiper(swiperContainer, config);
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
